module.exports = __webpack_public_path__ + "img/Menu-07.7fef2524.png";